import { buildScopeSummaryLabel } from '@features/proposals/ScopeSelector/scope-summary.helpers';
import { getSbefSelectionSummary } from '@features/sbef/sbef-summary.helpers';
import type { SbefScopeGroupKey } from '@shared/construction/sbef-custom-groups.data';
import type { Lifecycle } from '@shared/models/lifecycles.model';

export type ReportCoverScopeLines = {
  lcaModules: string;
  buildingParts: string;
};

/**
 * Cover-page copy for the active calculation scope (DEV-3533).
 * The PDF previously omitted omfattning (LCA modules / SBEF building parts);
 * the cover is where that declaration belongs. Empty lifecycle selection is
 * shown as "None"; unfiltered SBEF is "All".
 */
export const buildReportCoverScopeLines = (
  selectedLifecycles: Lifecycle[],
  lifetime: number,
  selectedSbefGroups: readonly SbefScopeGroupKey[],
): ReportCoverScopeLines => ({
  lcaModules:
    buildScopeSummaryLabel(selectedLifecycles, lifetime, [], false) || 'None',
  buildingParts: getSbefSelectionSummary(selectedSbefGroups),
});
